<!-- <div class="relative z-10 text-center px-4 mt-10">
    <h1 class="font-medium text-black text-xl md:text-2xl mb-4">Privacy Policy</h1>
</div> -->
<div class="min-h-screen bg-white text-[#111111]">
<div class="max-w-6xl mx-auto my-8 px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-8">
        <h3 class="font-bold text-lg sm:text-xl website-heading mb-4">Please read the Privacy Policy carefully</h3>
    </div>

    <div class="prose prose-sm max-w-none text-[#0A0A0A] leading-relaxed">

        <div class="mb-6">
            <p class="text-sm text-justify mb-3">
                Protecting your privacy and ensuring that your personal data is held securely is very important to
                Varroc Connect Private Limited ("Varroc" or "we/our/us" or the "Company", which includes its divisions,
                affiliates and group companies) and as such this Privacy Policy and Privacy Statement shall be referred
                and read as an integral part of the Terms of Use of the Website.
            </p>

            <p class="text-sm text-justify mb-3">
                We collect information about you when you visit our Website (www.varrocconnect.com), use our services,
                or view our online advertisements. The information we collect and store during normal use of the site is
                used to monitor your browsing pattern to help further development of our products and services.
            </p>

            <p class="text-sm text-justify mb-3">
                This Privacy Policy applies only to the Website. The text and graphic links on the Website may link to
                third-party social media sites, websites, and information and service providers that may also collect
                information from you. In addition, some of the pages on the Website may lead to co-branded web pages
                that are hosted and served by third parties. In each of the said cases, we have no control over the
                privacy policy of any third party and advise you to please examine their privacy policy prior to
                submitting any personal information.
            </p>

            <p class="text-sm text-justify mb-3">
                In general, you can visit the Website on the Internet without telling us who you are or providing
                personal information. Such use does not result in any personally identifiable data being collected or
                stored. We may, however, collect information about you when you visit the Website, use our services, or
                view our online advertisements. Having said that, unless you submit personal information by filling in
                any form on the Website or by sending us an e-mail, we are not obliged to maintain any other personal
                information as a result of your access and usage of this Website.
            </p>

            <p class="text-sm text-justify mb-3">
                The information we store are details collected during normal use of the Website by you and may be used
                to monitor your use of the Website thereof and to help further development of our products and services
                in India, or market or promote additional products and/or services to you, unless you specifically ask
                us in writing not to do so.
            </p>

            <p class="text-sm text-justify mb-3">
                We do not share your personal information with third parties, unless we need to share your personal
                information to provide the product(s) or service(s) you have requested, and we have asked for and
                obtained your explicit consent. The foregoing notwithstanding, if (1) disclosure was required by law,
                rule or regulation or was in response to a valid order of a court or authorized agency of government or
                other legal process and/or (2) When we find your action on the Website violates the terms and condition
                or any of your usage guidelines for specific products or services.
            </p>

            <p class="text-sm text-justify mb-4">
                This Privacy Policy will apply when you use the Website to discover more information about us and our
                products and/or services.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">International Data Transfers</h3>
            <p class="text-sm text-justify mb-3">
                Whilst any application, request, or enquiry you make may be passed or made available to our affiliates
                or subsidiaries ("Varroc Group affiliates"), some of which will be based in countries that do not have
                data protection laws, all Varroc Group affiliates are required to comply with an internal Privacy Policy
                which requires that steps are taken to protect your personal information and for it only to be used for
                the purpose(s) for which it was submitted.
            </p>

            <p class="text-sm text-justify mb-3">
                By submitting your personal information through this Website, you shall be consenting to it being
                processed in the manner described above by Varroc Group affiliates around the world and our hosting
                organizations around the world. If you wish to have us cease the use of your personal information
                submitted to us through this Website, please contact us. At any time, if you are concerned about the
                accuracy of the information we hold about you, please contact us to correct such information. We are
                strongly committed to protecting your privacy online and accordingly take security measures in relation
                to the information and personal data that is contained at our facilities. We restrict access to the
                Website, buildings, computer rooms, office desk, technology areas, equipment, and other facilities where
                unauthorised access by people could compromise our security.
            </p>

            <p class="text-sm text-justify mb-3">
                We also take appropriate technical and organizational measures to protect the personal information
                provided to us by you against accidental or unlawful destruction, or accidental loss, alteration,
                unauthorized disclosure or access. We also take further measures to comply with the relevant statement
                regarding what we can do with personal information we obtain from you.
            </p>

            <p class="text-sm text-justify mb-3">
                We endeavour to detect and investigate every breach of security by having relevant controls in place,
                which should alert us to a breach of security. We may also use encryption technology from time to time
                to assist in protecting any information or data that you submit. Having said that, we cannot and do not
                guarantee the security of any personal information or data you disclose online, having regard to the
                nature of the Internet. In any event, you accept the inherent security implications of disclosing
                information over the internet and agree not to hold us responsible for any breach of security unless we
                have been negligent or wilfully in default of our obligations under the relevant legislation.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Privacy Statement</h3>
            <p class="text-sm text-justify mb-3">
                Protecting your privacy and ensuring that your personal data is held securely is very important to
                Varroc & Varroc Engineering Limited ("Varroc" or "we/our/us" or the "Company", which includes its
                divisions, affiliates and group companies) and as such this Privacy Policy and Privacy Statement shall
                be referred and read as an integral part of the Terms of Use of the Website. We want you to be confident
                that we are looking after your interests, and that is why we have set out our information practices in
                this Privacy Statement. We are strongly committed to the protection of your privacy online and take
                appropriate technical and organizational measures to protect the personal information provided to us by
                you against accidental or unlawful destruction or accidental loss, alteration, unauthorized disclosure
                or access. We also take further measures to comply with the relevant statement regarding what we can do
                with personal information we obtain from you.
            </p>

            <p class="text-sm text-justify mb-3">
                However, we cannot guarantee the security of any personal information or data you disclose online,
                having regard to the nature of the Internet. In any event, you accept the inherent security implications
                of disclosing information over the internet and agree not to hold us responsible for any breach of
                security unless we have been negligent or wilfully in default of our obligations under the relevant
                legislation. The Company endeavours to detect and investigate every breach of security by having
                relevant controls in place, which should alert us to a breach of security. We may also use encryption
                technology from time to time to assist in protecting any information or data that you submit. At any
                time, if you are concerned that the information we hold about you is incorrect, please do not hesitate
                to contact us to correct such information.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Data Privacy Disclaimer</h3>
            <p class="text-sm text-justify mb-3">
                You declare that you are an Indian resident and shall not access the Website or access the products and
                services offered on the Website if you are not an Indian resident.
            </p>

            <p class="text-sm text-justify mb-3">
                <strong>Varroc respects your private sphere</strong>
            </p>

            <p class="text-sm text-justify mb-3">
                When processing personal data, we attach great importance to protecting your private sphere and ensuring
                that your data are secure. This data protection policy tells you about the data we process, why we need
                them, and how you can lodge an objection to the processing of your data.
            </p>

            <p class="text-sm text-justify mb-3">
                We collect, process, and store personal data (including IP addresses) only as permitted by law or if you
                have given your consent, for example, when registering for an event or a service or when registering for
                an account on the Website.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">What Data Do We Collect?</h3>
            <p class="text-sm text-justify mb-3">
                We collect several types of information from and about users of our Website, including information:
            </p>

            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">by which you may be personally identified, such as name, postal address, e-mail
                    address, telephone number, login address / password, financial or banking information, insurance
                    details, geo-location information when permitted by you on your device, details of transactions
                    carried out by you on or through the Website, or any other identifier by which you may be contacted
                    online or offline as well as other demographic data ("Personal Data");</li>
                <li class="text-sm">that is about you but individually does not identify you, including but not limited
                    to the type of interaction on our Website or other statistical information relating to the Website
                    use, and any other information provided by you on our Website ("Usage Information"); and/or</li>
                <li class="text-sm">User Contributions made by you (please refer to the Terms of Use for more
                    information), about your searches on our Website, products/ services checked or verified on our
                    Website, internet connection, the equipment you use to access our Website, and usage details.</li>
            </ul>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">How Do We Collect Data?</h3>
            <p class="text-sm text-justify mb-3">We collect this information:</p>

            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">Directly from you when you provide it to us on the Website, including when you
                    provide the information on the Website or create an account on the Website or otherwise during
                    online interaction or offline with Varroc's authorized dealerships.</li>
                <li class="text-sm">Automatically, as you navigate through the Website. Information collected
                    automatically may include usage details, internet protocol addresses, and information collected
                    through cookies and other tracking technologies.</li>
                <li class="text-sm">From third parties, for example, our business partners or service providers, who
                    have received the information from you with your consent to further disclose to third parties.</li>
            </ul>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Do We Pass Your Data on to Third Parties?</h3>
            <p class="text-sm text-justify mb-3">
                As a matter of principle, we pass your personal data on to third parties only if we are authorized by
                law to do so or if you have given your consent. This is the case, for example, when we display
                third-party services on our Website for your benefit.
            </p>

            <p class="text-sm text-justify mb-3">
                External service providers that process data on our behalf are contractually obliged to comply fully
                with the law on Data Protection. We make sure that such external service providers are capable of
                safeguarding data. Our prior consent is required before they are permitted to transfer responsibility
                for processing personal data to a third party.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">How Long Do We Retain Your Personal Data?</h3>
            <p class="text-sm text-justify mb-3">
                We retain your data as long as necessary for our business relationship with you, or as long as we have a
                legitimate interest in continuing to store the information. We delete your personal data in all other
                cases, except when continued storage is required under the law (for example, we are legally obligated to
                retain documents such as contracts and invoices for a period of 10 years).
            </p>
        </div>

        <!-- Data Deletion Section Start -->
        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Account Deletion</h3>
            <p class="text-sm text-justify mb-3">
                Users who wish to permanently delete their account and all associated personal data can submit a
                deletion request by contacting our support team at <a
                    (click)="openEmail(SupportEmail, 'Account Deletion Request')"
                    class="text-blue-600 hover:text-blue-800 underline cursor-pointer">{{SupportEmail}}</a> or click on the link
                mentioned below to send the request for account deletion.
            </p>

            <p class="text-sm text-justify mb-3">
                For security verification, please use the same email address registered with your account, or mention
                your <strong>registered email address or mobile number</strong> in the body of the email. Kindly include
                <strong>“Account Deletion Request”</strong> in the subject line.
            </p>

            <p class="text-sm text-justify mb-3">
                Upon receiving your request, we will: </p>

            <ul class="list-decimal list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">Verify the user identity over email ID and call. </li>
                <li class="text-sm">Permanently delete your account and all related personal information from our
                    systems within <strong>7 business days.</strong> </li>
                <li class="text-sm">Send a confirmation email once the deletion process is complete. </li>
            </ul>

            <p class="text-sm text-justify mb-3">
                Please note that once the account is deleted, all associated data will be permanently removed and cannot
                be recovered. </p>

            <p class="text-sm text-justify mb-3 mt-3">
                Link for sending account deletion request:</p>


            <p class="text-sm text-justify mb-3">
                <a class="text-blue-600 hover:text-blue-800 underline cursor-pointer break-all"
                    (click)="openExternalUrl('https://forms.office.com/Pages/ResponsePage.aspx?id=XjgikCt5wEiyCGuVS0-v3HOWCfXywKVEuk6NvbwWlINUQVZYWlBRVllaR04zSTFCUVlXUVNKMUJDSi4u')">https://forms.office.com/Pages/ResponsePage.aspx?id=XjgikCt5wEiyCGuVS0-v3HOWCfXywKVEuk6NvbwWlINUQVZYWlBRVllaR04zSTFCUVlXUVNKMUJDSi4u</a>
            </p>
        </div>
        <!-- Data Deletion Section End -->

        <!-- Billing, Pricing, and Payment Terms Section Start -->
        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Billing, Pricing, and Payment Terms</h3>
            <p class="text-sm text-justify mb-3">
                This section outlines the billing policies, pricing, and payment terms applicable to the Varroc Connect Device and related subscription services.
            </p>

            <div class="mb-4">
                <h4 class="font-semibold text-base mb-2 text-black">A. Billing Policies</h4>
                
                <div class="ml-3 mb-3">
                    <p class="text-sm text-justify mb-2"><strong>1.</strong> If you subscribe to any Device hardware-based services, you agree to the pricing and payment terms presented at the time of subscription.</p>
                    
                    <p class="text-sm text-justify mb-2"><strong>2.</strong> Varroc Connect reserves the right to introduce or unlock new hardware features for an additional fee or adjust fees linked to the device for existing services at its sole discretion. Any change in pricing or payment terms will apply only to subsequent billing cycles, and you will be notified at least thirty (30) days in advance.</p>
                </div>
            </div>

            <div class="mb-4">
                <h4 class="font-semibold text-base mb-2 text-black">B. Pricing and Payment Terms</h4>
                
                <div class="ml-3 mb-3">
                    <p class="text-sm text-justify mb-2"><strong>1. Subscription Fees</strong></p>
                    <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                        <li class="text-sm">Subscription fees for the hardware services or features, including applicable taxes and charges ("Subscription Fees"), are payable in advance at the start of the subscription term.</li>
                        <li class="text-sm">Subscriptions are offered on annual ("Annual Subscription") basis.</li>
                        <li class="text-sm">For Annual Subscriptions, you will receive a reminder at least thirty (45) days prior to renewal with the then-current Subscription Fee. We may provide similar reminders for other subscriptions as required.</li>
                        <li class="text-sm">Varroc Connect reserves the right to update Subscription Fees. Advance notice will be provided, and you may cancel your subscription if you do not agree with the revised pricing.</li>
                    </ul>
                    
                    <p class="text-sm text-justify mb-2"><strong>2. Subscription Changes</strong></p>
                    <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                        <li class="text-sm">If you upgrade or change your hardware subscription type, your billing date may change.</li>
                    </ul>
                    
                    <p class="text-sm text-justify mb-2"><strong>3. Payment Methods</strong></p>
                    <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                        <li class="text-sm">Payments may be made via accepted credit/debit cards or other payment methods as supported.</li>
                        <li class="text-sm">By completing a purchase ("Transaction"), you authorize our third-party payment processor to process your payment and, if necessary, request additional information such as card details, expiration date, and billing address ("Payment Information").</li>
                        <li class="text-sm">You confirm that you have the legal right to use the provided payment method. Varroc Connect is not liable for any acts or omissions of your payment provider.</li>
                        <li class="text-sm">Transactions may require identity verification before completion.</li>
                        <li class="text-sm">Varroc Connect is not responsible for fees or penalties (e.g., overdraft fees, credit limit issues) arising from charges billed under this Agreement.</li>
                    </ul>
                    
                    <p class="text-sm text-justify mb-2"><strong>4. Pricing Changes</strong></p>
                    <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                        <li class="text-sm">Subscription prices may be updated periodically to reflect inflation, regulatory requirements, or business needs. Advance notice will be provided prior to implementation. If you do not wish to continue at the new rate, you may cancel your subscription before the price change takes effect.</li>
                    </ul>
                </div>
            </div>

            <div class="mb-4">
                <h4 class="font-semibold text-base mb-2 text-black">C. Refunds</h4>
                
                <div class="ml-3 mb-3">
                    <p class="text-sm text-justify mb-2"><strong>1. No Refund Policy</strong></p>
                    <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                        <li class="text-sm">All subscription and service fees are non-refundable.</li>
                        <li class="text-sm">Cancellation does not entitle you to any refund for unused subscription time, content, or data associated with your account.</li>
                        <li class="text-sm">For example, if you purchase an annual subscription and cancel after two months, you will retain access to the service for the remaining ten (10) months but will not receive a refund.</li>
                    </ul>
                </div>
            </div>

            <div class="mb-4">
                <h4 class="font-semibold text-base mb-2 text-black">D. Cancellation and Account Closure</h4>
                
                <div class="ml-3 mb-3">
                    <p class="text-sm text-justify mb-2"><strong>1. Cancel Subscription or Close Account</strong></p>
                    <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                        <li class="text-sm">You may cancel your subscription or close your account at any time by contacting our support team at <a [href]="'mailto:' + SupportEmail"
                   class="text-blue-600 hover:text-blue-800 underline">{{SupportEmail}}</a> or click on the Delete My Account button in the Varroc Connect App.</li>
                        <li class="text-sm">Please include your full name, registered email address, and a valid contact number in your request, if the user is sending an email confirmation for account deletion.</li>
                        <li class="text-sm">Upon cancellation:
                            <ul class="list-disc list-inside ml-6 mt-1 space-y-1">
                                <li class="text-sm">Your access to the Service will be terminated.</li>
                                <li class="text-sm">The connected telematics device will be deactivated.</li>
                            </ul>
                        </li>
                        <li class="text-sm">To reactivate a deactivated device or reopen an account, you must contact customer support.</li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- Billing, Pricing, and Payment Terms Section End -->

        <!-- Add content here -->
         
        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">What Data Are Processed When You Use Our Website?</h3>
            <p class="text-sm text-justify mb-3">
                In general, you may visit our Website without providing personal information. When you visit the site,
                our servers make a temporary record of each access in a log file. The following technical data are
                collected and stored until they are automatically deleted after no more than seven months:
            </p>

            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">The IP address of the computer used to access the site</li>
                <li class="text-sm">GPS location of the User, if allowed by the User</li>
                <li class="text-sm">The date and time of access</li>
                <li class="text-sm">The website from which access was obtained, as well as the search term used, as
                    applicable</li>
                <li class="text-sm">The name and URL of the accessed file</li>
                <li class="text-sm">The search queries used</li>
                <li class="text-sm">Your computer's operating system (shown by the user agent)</li>
                <li class="text-sm">The browser you are using (shown by the user agent)</li>
                <li class="text-sm">The type of device, if access is obtained through a mobile telephone</li>
                <li class="text-sm">The transmission protocol used</li>
            </ul>

            <p class="text-sm text-justify mb-3">
                By collecting and processing these data, we promote system security and stability, allow for error and
                performance analysis, and serve internal statistical needs. This also enables us to optimize our online
                services. In addition, IP addresses are used to preset the Website.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Cookies and Tracking Technologies</h3>
            <p class="text-sm text-justify mb-3">
                We may use any available technology for such automatic data collection, including but not limited to:
            </p>

            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm"><strong>Cookies (or browser cookies)</strong> – explained in further detail below.
                </li>
                <li class="text-sm"><strong>Flash Cookies.</strong> Certain features of our website may use local stored
                    objects (or flash cookies) to collect and store information about your preferences and navigation
                    to, from, and on our Website. Flash cookies are not managed by the same browser settings as are used
                    for browser cookies, and we advise you to keep yourself updated on how to manage your privacy and
                    security settings for flash cookies on your device.</li>
                <li class="text-sm"><strong>Web Beacons.</strong> Pages of our Website and our e-mails may contain small
                    electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel
                    gifs) that permit Varroc, for example, to count users who have visited those pages or opened an
                    email and for other related website statistics (for example, recording the popularity of certain
                    website content and verifying system and server integrity).</li>
            </ul>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">What Are Cookies, and When Are They Used?</h3>
            <p class="text-sm text-justify mb-3">
                Cookies are small text files that are placed on your computer when you visit our Website. When you
                return to the Website, your browser transmits the information contained in the cookies back to us, and
                this allows the system to recognize your terminal device. With the help of cookies, we are able to
                optimize our website and facilitate its use.
            </p>

            <p class="text-sm text-justify mb-3">
                When you visit our website, a pop-up message informs you of our use of cookies and of the fact that
                visiting the site implies your consent. If you opt not to permit the use of cookies, you may deactivate
                and delete all cookies at any time. For more information, consult your browser's help function. If you
                choose to deactivate cookies, however, certain functions on our Website may no longer be available to
                you. The deactivation or deletion process must be repeated if you use a different browser or terminal
                device.
            </p>

            <p class="text-sm text-justify mb-3">
                To manage or deactivate the use of cookies by third-party providers, visit the respective website. As we
                do not operate their website, we are not responsible for it, nor do we have any influence on its
                contents or accessibility.
            </p>

            <p class="text-sm text-justify mb-3">
                In addition to the data listed above (see "What data are processed when you use our websites?"), we
                gather the following information:
            </p>

            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">The user's navigation path on the Website</li>
                <li class="text-sm">The length of time the user spends on the Website or subpage</li>
                <li class="text-sm">The subpage from which the user leaves the Website</li>
                <li class="text-sm">The country, region or city from which the Website is accessed</li>
                <li class="text-sm">The terminal device (type, version, color depth, resolution, width, and height of
                    the browser window)</li>
            </ul>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Social Media and Third-Party Links</h3>
            <p class="text-sm text-justify mb-3">
                Our website contains plugins and links to several social networks and third-party websites (Facebook,
                Twitter, LinkedIn, Google+, etc.). The links are marked with the logos of the providers. Clicking on a
                link takes you to the relevant social media platform or third-party platform, where this data protection
                policy does not apply. The provisions that apply there can be found in the data protection policy posted
                on the respective provider's website.
            </p>

            <p class="text-sm text-justify mb-3">
                Personal information is not transmitted to the social media provider or the third-party service provider
                until you click on a link or plugin. By accessing the linked site, you are allowing the provider to
                process your data. We have no control or influence over such data processing, nor do we have information
                about the extent of data collection, the purposes for which the data are processed, or the retention
                period. We have no information about the deletion of data by the plugin provider.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Newsletter</h3>
            <p class="text-sm text-justify mb-3">
                You can subscribe to newsletters through our online services. We use the so-called "double opt-in"
                method; this means that if you want to receive our email newsletter, you must confirm your request by
                clicking on a link in a message. If you subsequently decide that you no longer want to receive our
                newsletter, you can cancel your subscription at any time, effective going forward, by revoking your
                consent. This can be done by clicking on a link in the email newsletter. Alternatively, you can contact
                us using the information in the Contact section.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">What Rights Do You Have Concerning Your Personal Data?
            </h3>
            <p class="text-sm text-justify mb-3">You have the following rights:</p>

            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">You are entitled to request information about your stored data.</li>
                <li class="text-sm">You may request that your personal data be corrected, supplemented, blocked or
                    deleted.</li>
                <li class="text-sm">You may do so via letter or email. See Contact section.</li>
            </ul>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Data Security</h3>
            <p class="text-sm text-justify mb-3">
                We use appropriate technical and organizational security measures to protect stored personal data
                against manipulation, partial or total loss, and unauthorized access by third parties. Our security
                measures are continually upgraded as technology advances.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Amending This Data Protection Policy</h3>
            <p class="text-sm text-justify mb-3">
                We reserve the right to amend or supplement this policy at any time, as we see fit and in accordance
                with data protection law. Please consult this policy on a regular basis.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Contact</h3>
            <p class="text-sm text-justify mb-3">
                If you have questions about your rights concerning your personal data or related issues, please write to
                us at <a [href]="'mailto:' + SupportEmail"
                    class="text-blue-600 hover:text-blue-800 underline">{{SupportEmail}}</a>
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Contacting Us</h3>
            <p class="text-sm text-justify mb-3">
                We have taken adequate measures to secure access to your personal data. We regularly review our
                compliance with this Privacy Policy and Privacy Statement. Please feel free to direct any questions or
                concerns regarding this Privacy Policy or Privacy Statement or our treatment of Personal Data and
                information by completing our web contact form or by writing to us at the following addresses:
            </p>

            <div class="ml-3 mb-3">
                <p class="text-sm mb-1"><strong>To: </strong> Varroc Connect Private Limited</p>
                <p class="text-sm mb-1"><strong>Address: </strong> Elpro International, Chinchwad Station Rd, Chinchwad
                    Gaon, Chinchwad, Pimpri-Chinchwad, Maharashtra 411033</p>
                <p class="text-sm mb-1"><strong>Email Id: </strong> <a [href]="'mailto:' + SupportEmail"
                        class="text-blue-600 hover:text-blue-800 underline">{{SupportEmail}}</a></p>
                <p class="text-sm mb-1"><strong>Phone:</strong> 9579292320</p>
            </div>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Changes to This Policy</h3>
            <p class="text-sm text-justify mb-3">
                Company may edit this policy from time to time. If we make any substantial changes, we will notify you
                by posting a prominent announcement on our pages.
            </p>
        </div>

    </div>
</div>
</div>